import React from 'react';
//import PropTypes from 'prop-types';

import decorate from '../common/utils/decorate';
import DeliveryWidgetContext from '../contexts/DeliveryWidgetContext';
import Button from '../ui/Button';
import Card from '../ui/Card';
import Grid from '../ui/Grid';
import Text from '../ui/Text';

export default decorate(
  class extends React.PureComponent {
    static contextType = DeliveryWidgetContext;

    static decorateWith = {};

    static propTypes = {};

    static defaultProps = {};

    constructor(props) {
      super(props);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
      const { onPrevPage } = this.props;

      const { langString } = this.context;

      return (
        <Card>
          <Grid container>
            <Grid>
              <Grid container>
                <Grid align="center">
                  <Text color="hint" size="xl2">
                    {langString('cart.empty')}
                  </Text>
                </Grid>
              </Grid>

              {onPrevPage ? (
                <Button variant="outlined" onClick={onPrevPage}>
                  {langString('return')}
                </Button>
              ) : null}
            </Grid>
          </Grid>
        </Card>
      );
    }
  }
);
